import 'react-toastify/dist/ReactToastify.css'; // Import styles
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';

import { all_routes } from '../router/all_routes';
import { AppDispatch, RootState } from '../../core/data/redux/store';
import { loginUser, resetAuth } from '../../core/data/redux/action';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';

// import AppleSignin from 'react-apple-signin-auth';
// import { FaApple } from 'react-icons/fa'; // Apple icon

type FormValues = {
  email: string;
  password: string;
};

const routes = all_routes;

const Login = () => {
  const [isToggle, setIsToggle] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { success, error } = useSelector((state: RootState) => ({
    success: state.auth.success,
    error: state.auth.error,
  }));

  useEffect(() => {
    dispatch(resetAuth());
    window.scrollTo(0, 0);
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(loginUser(data.email, data.password));
  };

  const [toastMessage, setToastMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [toastClass, setToastClass] = useState('bg-success text-white');

  useEffect(() => {
    if (success) {
      showToast(success);
      reset();
      navigate(routes.userBookings);

      window.location.reload();
      dispatch(resetAuth());
    } else if (error) {
      setErrorMessage(error);
      showToast(error);
      // reset();
    }
  }, [success, error]);

  const showToast = (message: any) => {
    setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white');

    setToastMessage(message);
  };

  const handleCloseToast = () => {
    dispatch(resetAuth());
    setToastMessage('');
  };

  return (
    <div className="main-wrapper login-body">
      <header className="log-header">
        <Link to={routes.homeOne}>
          <ImageWithBasePath
            className="img-fluid logo-dark"
            src="assets/img/logo/fairRentallogo.png"
            alt="Logo"
          />
        </Link>
      </header>
      {toastMessage && (
        <>
          {toastClass === 'bg-danger text-white'
            ? toast.error(toastMessage, {
                position: 'top-right',
                hideProgressBar: true,
                onClose: handleCloseToast,
                progress: undefined,
                toastId: '',
              })
            : toast.success(toastMessage, {
                position: 'top-right',
                hideProgressBar: true,
                onClose: handleCloseToast,
                progress: undefined,
                toastId: '',
              })}
          {toastMessage && <ToastContainer autoClose={3000} limit={1} />}
        </>
      )}

      <div className="login-wrapper">
        <div className="loginbox">
          <div className="login-auth">
            <div className="login-auth-wrap">
              <div className="sign-group">
                <Link
                  to={routes.homeOne}
                  className="border-0 btn sign-up d-flex align-items-center"
                >
                  <i className="bx bx-arrow-back fs-5 me-2"></i>

                  <span className="mt-1"> Back To Home </span>
                </Link>
              </div>
              <h1>Sign In</h1>
              <p className="account-subtitle">
                We will send a confirmation code to your email.
              </p>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-block">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    {...register('email', { required: 'Email is required' })}
                  />
                  {errors.email && (
                    <p className="text-danger">{errors.email.message}</p>
                  )}
                </div>

                <div className="input-block">
                  <label className="form-label">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isToggle ? 'text' : 'password'}
                      className="form-control pass-input"
                      {...register('password', {
                        required: 'Password is required',
                      })}
                    />
                    <span
                      onClick={() => setIsToggle(!isToggle)}
                      className={`fas toggle-password ${isToggle ? 'fa-eye' : 'fa-eye-slash'}`}
                    />
                  </div>
                  {errors.password && (
                    <p className="text-danger">{errors.password.message}</p>
                  )}
                </div>

                {errorMessage && (
                  <div>
                    <p className="text-danger"> {errorMessage} </p>
                  </div>
                )}

                <div className="input-block">
                  <Link className="forgot-link" to={routes.forgotPassword}>
                    Forgot Password?
                  </Link>
                </div>

                {/* <div className="input-block m-0">
                  <label className="custom_check d-inline-flex">
                    <span>Remember me</span>
                    <input type="checkbox" name="remember" />
                    <span className="checkmark" />
                  </label>
                </div> */}

                {/* Fix: Use a button instead of a Link */}
                <button
                  type="submit"
                  className="btn btn-primary w-100 btn-size mt-1 py-2"
                >
                  Sign In
                </button>

                {/* <div className="login-or d-flex  py-1 justify-content-center ">
                  <span className="span-or-log">Or, log in with your email</span>
                </div> */}

                {/* Google Login */}
                {/* <div className="social-login my-2">


                  <GoogleLoginComponent />

                  <AppleSignin
                    authOptions={{
                      clientId: "com.fairtech.Fairental",
                      scope: "name",
                      redirectURI: "https://c5d9-122-165-122-28.ngrok-free.app/api/auth/apple/callback",
                      usePopup: true,
                    }}
                    uiType={"light"}
                    onSuccess={async (response: any) => {
                      const idToken = response.authorization.id_token;

                      try {
                        const res = await fetch('https://your-backend-url.com/api/auth/apple/callback', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({ id_token: idToken }),
                        });

                        const data = await res.json();
                      
                        if (data.token) {
                          localStorage.setItem('authToken', data.token);
                          // optionally redirect
                        } else {
                          console.error('Token missing in backend response');
                        }
                      } catch (error) {
                        console.error('Error sending token to backend', error);
                      }
                    }}
                    onError={(error: any) => console.error(error, "Apple login failed")}

                    render={(props: any) => (

                      <div className="py-2">
                        <button type="button" onClick={props.onClick} className="btn    btn-size  "
                          style={{ padding: "10px 20px", border: "1px solid #d1d5db", borderRadius: "30px" }}
                        >  <FaApple size={20} className="me-1" /> Sign in to your account with Apple</button>
                      </div>

                    )}
                  />

                </div> */}

                <div className="text-center dont-have mt-2">
                  <Link to={routes.register}>Register</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <footer className="log-footer">
        <div className="container-fluid">
          <div className="copyright">
            <div className="copyright-text">
              <p>© 2025 FaiRental. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;
